import React from 'react';
import { injectIntl } from 'react-intl';
import { GoogleLogin, GoogleLoginResponse, GoogleLoginResponseOffline } from 'react-google-login';
import { GOOGLE_OAUTH_ACCESS_TYPE, GOOGLE_OAUTH_CLIENT_ID, GOOGLE_OAUTH_COOKIE_POLICY, GOOGLE_OAUTH_PROMPT } from '../../constants';

interface GoogleLoginWrapperProps {
    onSuccess: (response: GoogleLoginResponse | GoogleLoginResponseOffline) => void;
    buttonComponent: (props: {
        onClick: () => void;
        disabled?: boolean;
    }) => JSX.Element;
    onFailure?: (error: any) => void;
}

export const GoogleLoginWrapper = ({ onSuccess, buttonComponent, onFailure = () => {} }:  GoogleLoginWrapperProps) => (
    <GoogleLogin
        clientId={GOOGLE_OAUTH_CLIENT_ID}
        onSuccess={onSuccess}
        onFailure={onFailure}
        accessType={GOOGLE_OAUTH_ACCESS_TYPE}
        prompt={GOOGLE_OAUTH_PROMPT}
        cookiePolicy={GOOGLE_OAUTH_COOKIE_POLICY}
        render={buttonComponent}
    />
);

export const GoogleLoginWrapperComponent = injectIntl(GoogleLoginWrapper);
